<template>
  <div
    v-loading="isLoading || isCategoriesLoading"
    class="team-permissions"
  >
    <ElCollapse v-model="activePermissions">
      <ElCollapseItem
        :title="$t(`permissions.reports.title`)"
        name="reports"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.reports.reports_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view')" />
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.reports_affiliates_types"
                  :disabled="pvPermissions.reports_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.reports_view_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.reports_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.reports_affiliates_types"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.reports.reports_group_by`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('reports_group_by_affiliates')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_group_by_countries')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_group_by_sub_affiliates')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_group_by_payments')" />
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.reports.reports_view_columns`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_revenue_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_profit_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_deposits_sum_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_deposits_count_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_withdrawals_sum_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_withdrawals_count_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_sport_bets_sum_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_sport_bets_count_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_casino_bets_sum_columns')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('reports_view_casino_bets_count_columns')" />
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.affiliates.title`)"
        name="affiliates"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_view')" />
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.affiliates_types_view"
                  :disabled="pvPermissions.affiliates_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.affiliates_view_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.affiliates_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.affiliates_types_view"
                  />
                </UiCheckboxGroup>
              </div>

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_edit')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.affiliates_types_edit"
                  :disabled="pvPermissions.affiliates_edit === 'deny' || pvPermissions.affiliates_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.affiliates_edit_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.affiliates_edit === 'deny' || pvPermissions.affiliates_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.affiliates_types_edit"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_sub_affiliates`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_sub_affiliates_edit_settings')" />

              <div class="field field-input">
                <span class="label">{{ $t(`permissions.affiliates.affiliates_sub_affiliates_max_percent`) }}</span>
                <div class="values ">
                  <UiInput
                    v-model="pvPermissions.affiliates_sub_affiliates_max_percent"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_sub_affiliates_edit_settings === 'deny' || pvPermissions.affiliates_edit === 'deny'"
                    :error="errors.affiliates_sub_affiliates_max_percent"
                    error-tooltip
                    class=""
                    width="80px"
                    post-text="%"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_actions_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_activity_log_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_login')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_payment_info_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_domain_change_notifications_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_reporting_settings_rs_profit_visibility_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_reporting_settings_cpa_profit_visibility_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_email_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_payments_can_create')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('payments_external_payouts_actions')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_media_buying_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_promo_codes_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_balance_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_rotation_groups_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_limits_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_traffic_block_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_kyc_request')" />
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_kyc_skip')" />
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.offers.offers_catalog_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('offers_catalog_edit')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.offers.offers_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('offers_edit')" />
              <PermissionTreeCommon
                v-if="!isCategoriesLoading"
                v-model:mode="pvPermissions.offers_link_to_catalog_categories_allowed_mode"
                v-model:ids="pvPermissions.offers_link_to_catalog_categories_allowed_list"
                class="field"
                :label="$t('permissions.offers.use_from_catalog')"
                :disabled="pvPermissions.offers_edit === 'deny'"
                :select-placeholder="$t('permissions.offers.select_categories')"
                :field-list="dataCategories"
                :permission-types="['allow_all', 'allow_selected', 'deny_selected']"
                @update:mode="onOffersCatalogModeChange"
                @update:ids="onOffersCatalogIdsChange"
              />
              <Vnodes :vnodes="renderPermissionSwitchControl('offers_delete')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.offers.offers_revshare`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('offers_revshare_edit_settings')" />

              <div class="field field-input">
                <span class="label">{{ $t(`permissions.offers.offers_revshare_max_percent_sport`) }}</span>
                <div class="values ">
                  <UiInput
                    v-model="pvPermissions.offers_revshare_max_percent_sport"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_edit === 'deny' || pvPermissions.offers_edit === 'deny' || pvPermissions.offers_revshare_edit_settings === 'deny'"
                    :error="errors.offers_revshare_max_percent_sport"
                    error-tooltip
                    width="80px"
                    post-text="%"
                  />
                </div>
              </div>
              <div class="field field-input">
                <span class="label">{{ $t(`permissions.offers.offers_revshare_max_percent_casino`) }}</span>
                <div class="values ">
                  <UiInput
                    v-model="pvPermissions.offers_revshare_max_percent_casino"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_edit === 'deny' || pvPermissions.offers_edit === 'deny' || pvPermissions.offers_revshare_edit_settings === 'deny'"
                    :error="errors.offers_revshare_max_percent_casino"
                    error-tooltip
                    width="80px"
                    post-text="%"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.offers.offers_cpa`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('offers_cpa_edit_settings')" />
              <div class="field field-input select">
                <span class="label">{{ $t(`permissions.offers.offers_cpa_max_payout_currency`) }}</span>
                <div class="values">
                  <UiSelectElement
                    v-model="pvPermissions.offers_cpa_max_payout_currency_code"
                    :placeholder="$t('permissions.offers.not_selected')"
                    :list="currencyOptions"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_edit === 'deny' || pvPermissions.offers_edit === 'deny' || pvPermissions.offers_cpa_edit_settings === 'deny'"
                    filterable
                    :width="160"
                    option-value-param="code"
                    :error="getError('offers_cpa_max_payout_currency_code')"
                  />
                </div>
              </div>
              <div class="field field-input">
                <span class="label">{{ $t(`permissions.offers.offers_cpa_max_payout`) }}</span>
                <div class="values ">
                  <UiInput
                    v-model="pvPermissions.offers_cpa_max_payout"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_edit === 'deny' || pvPermissions.offers_edit === 'deny' || pvPermissions.offers_cpa_edit_settings === 'deny'"
                    :error="getError('offers_cpa_max_payout')"
                    error-tooltip
                    width="80px"
                  />
                </div>
              </div>
              <div class="field field-input">
                <span class="label">{{ $t(`permissions.offers.offers_cpa_min_payout_deposits_sum_ratio`) }}</span>
                <div class="values ">
                  <UiInput
                    v-model="pvPermissions.offers_cpa_min_payout_deposits_sum_ratio"
                    :disabled="pvPermissions.affiliates_view === 'deny' || pvPermissions.affiliates_edit === 'deny' || pvPermissions.offers_edit === 'deny' || pvPermissions.offers_cpa_edit_settings === 'deny'"
                    :error="getError('offers_cpa_min_payout_deposits_sum_ratio')"
                    error-tooltip
                    width="80px"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_notes`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_notes_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_notes_edit')" />
            </div>
          </div>

          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_security_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_password_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_2fa_can_reset')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_status_change_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_approve')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_decline')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_block')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_unblock')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_can_revoke')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_notifications`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_notifications_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_notifications_edit')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.affiliates.affiliates_kpi`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t('permissions.status') }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('affiliates_kpi_bonuses_edit')" />
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.payments.title`)"
        name="payments"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.payments.payments_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('payments_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('payments_review_actions')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('payments_chargebacks_actions')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('payments_make_manual_cpa_payouts')" />
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.players.title`)"
        name="players"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.players.players_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('players_view')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.players_available_property_groups"
                  :disabled="pvPermissions.players_view === 'deny'"
                  :options="[
                    {
                      label: $t('permissions.players.subId'),
                      value: 'sub_id',
                    },
                    {
                      label: $t('permissions.players.country'),
                      value: 'country',
                    },
                    {
                      label: $t('permissions.players.personal_information'),
                      value: 'personal_information',
                    },
                    {
                      label: $t('permissions.players.affiliate'),
                      value: 'affiliate',
                    },
                    {
                      label: $t('permissions.players.contacts'),
                      value: 'contacts',
                    },
                    {
                      label: $t('permissions.players.visit'),
                      value: 'visit_information',
                    },
                  ]"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.players.players_card_other`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('players_virtual_edit_settings')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('players_assign_affiliate')" />
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.dms.title`)"
        name="dms"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.dns_hosting_accounts`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('dns_hosting_accounts_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('dns_hosting_accounts_edit')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.domain_registrar_accounts`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('domain_registrar_accounts_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('domain_registrar_accounts_edit')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.platform_servers`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('platform_servers_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('platform_servers_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('platform_servers_can_run_jobs')" />
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.platform_service_domains`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('platform_service_domains_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('platform_service_domains_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('platform_service_domains_can_run_jobs')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.service_rotation_groups`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('service_rotation_groups_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('service_rotation_groups_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('service_rotation_groups_domains_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('service_rotation_groups_domains_edit')" />
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.dms.dedicated_site_domains`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('platform_betting_domains_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('platform_betting_domains_edit')" />
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.media_buying.title`)"
        name="media-buying"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.media_buying.payments`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('media_buying_payments_view')" />
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_payments_affiliates_types_view"
                  :disabled="pvPermissions.media_buying_payments_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.media_buying_payments_view_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.media_buying_payments_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.media_buying_payments_affiliates_types_view"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('media_buying_payments_review')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_payments_affiliates_types_review"
                  :disabled="pvPermissions.media_buying_payments_review === 'deny' || pvPermissions.media_buying_payments_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.media_buying_payments_review_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.media_buying_payments_review === 'deny' || pvPermissions.media_buying_payments_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.media_buying_payments_affiliates_types_review"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.media_buying.payments_moderation`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.media_buying.statuses`) }}</span>
              </div>
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_payments_moderation_statuses_visible"
                  :disabled="pvPermissions.media_buying_payments_view === 'deny'"
                  :options="statusList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                />
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.media_buying.payments_payout`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.media_buying.statuses`) }}</span>
              </div>
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_payments_payout_statuses_visible"
                  :disabled="pvPermissions.media_buying_payments_view === 'deny'"
                  :options="[
                    {
                      label: $t('permissions.not_paid'),
                      value: 'not_paid',
                    },
                    {
                      label: $t('permissions.paid'),
                      value: 'paid',
                    },
                    {
                      label: $t('permissions.for_rework'),
                      value: 'for_rework',
                    },
                    {
                      label: $t('permissions.failed'),
                      value: 'failed',
                    },
                    {
                      label: $t('permissions.processing'),
                      value: 'processing',
                    },
                  ]"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.media_buying.posts`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('media_buying_posts_view')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_posts_affiliates_types_view"
                  :disabled="pvPermissions.media_buying_posts_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.media_buying_posts_view_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.media_buying_posts_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.media_buying_posts_affiliates_types_view"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('media_buying_posts_review')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_posts_affiliates_types_review"
                  :disabled="pvPermissions.media_buying_posts_view === 'deny' || pvPermissions.media_buying_posts_review === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.media_buying_posts_review_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.media_buying_posts_view === 'deny' || pvPermissions.media_buying_posts_review === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.media_buying_posts_affiliates_types_review"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.media_buying.statuses`) }}</span>
              </div>
              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_posts_statuses_visible"
                  :disabled="pvPermissions.media_buying_posts_view === 'deny'"
                  :options="statusList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                />
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.reports.reports_card_title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <Vnodes :vnodes="renderPermissionSwitchControl('media_buying_reports_view')" />

              <div class="field">
                <UiCheckboxGroup
                  v-model="pvPermissions.media_buying_reports_affiliates_types_view"
                  :disabled="pvPermissions.media_buying_reports_view === 'deny'"
                  :options="partnersTypeList"
                  group-class-name="team-permissions__checkbox-group"
                  button-class-name="team-permissions__checkbox"
                >
                  <PermissionTree
                    v-model:teammates-ids="pvPermissions.media_buying_reports_view_affiliates_visibility_teammates_id"
                    :disabled="pvPermissions.media_buying_reports_view === 'deny'"
                    :users-list="users"
                    :affiliates-types="pvPermissions.media_buying_reports_affiliates_types_view"
                  />
                </UiCheckboxGroup>
              </div>
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.crm.title`)"
        name="crm"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.crm.segments`) }}</span>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.segments_view`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_segments_view"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.segments_edit`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_segments_edit"
                  :disabled="pvPermissions.crm_segments_view === 'deny'"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :disabled="isDisabledOption('crm_segments_view', item.value)"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.segments_review`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_segments_review"
                  :disabled="pvPermissions.crm_segments_edit === 'deny' || pvPermissions.crm_segments_view === 'deny'"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :disabled="isDisabledOption('crm_segments_edit', item.value)"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
          </div>
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.crm.activities`) }}</span>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.activities_view`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_activities_view"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.activities_edit`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_activities_edit"
                  :disabled="pvPermissions.crm_activities_view === 'deny'"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :disabled="isDisabledOption('crm_activities_view', item.value)"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.activities_review`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_activities_review"
                  :disabled="pvPermissions.crm_activities_view === 'deny'"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :disabled="isDisabledOption('crm_activities_view', item.value)"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`permissions.crm.activities_run`) }}</span>
              </div>
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.crm_activities_run"
                  :disabled="pvPermissions.crm_activities_view === 'deny'"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                >
                  <template v-slot:buttons>
                    <UiRadioButton
                      v-for="(item, id) in crmRadioList"
                      :key="id"
                      class="team-permissions__radio-button"
                      :disabled="isDisabledOption('crm_activities_view', item.value)"
                      :value="item.value"
                      :text="item.label"
                    />
                  </template>
                </UiRadioGroup>
              </div>
            </div>
          </div>
        </div>
      </ElCollapseItem>
      <ElCollapseItem
        :title="$t(`permissions.others.title`)"
        name="others"
      >
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.tools.title`) }}</span>
              <span>
                <span class="radio-block radio-block_allow">
                  {{ $t(`permissions.status`) }}
                </span>
              </span>
            </div>
            <div class="card-content">
              <!--              <Vnodes :vnodes="renderPermissionSwitchControl('tools_promo_codes_checker_view')" />-->


              <Vnodes :vnodes="renderPermissionSwitchControl('tools_promo_landings_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('tools_promo_landings_edit')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('marketing_materials_view')" />

              <Vnodes :vnodes="renderPermissionSwitchControl('marketing_materials_edit')" />
            </div>
          </div>
          <!--          <div class="card">-->
          <!--            <div class="title">-->
          <!--              <span>{{ $t(`permissions.live.live_card_title`) }}</span>-->
          <!--              <span>-->
          <!--                <span class="radio-block radio-block_allow">-->
          <!--                  {{ $t(`permissions.status`) }}-->
          <!--                </span>-->
          <!--              </span>-->
          <!--            </div>-->
          <!--            <div class="card-content">-->
          <!--              <Vnodes :vnodes="renderPermissionSwitchControl('last_bets_and_deposits_view')" />-->

          <!--              <Vnodes :vnodes="renderPermissionSwitchControl('top_events_view')" />-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <div class="permission-column">
          <div class="card">
            <div class="title">
              <span>{{ $t(`permissions.geo.geo_card_title`) }}</span>
            </div>
            <div class="card-content">
              <div class="field">
                <UiRadioGroup
                  v-model="pvPermissions.countries_allowed_mode"
                  :options="[
                    {
                      label: $t('permissions.allow_all'),
                      value: 'allow_all',
                    },
                    {
                      label: $t('permissions.allow_selected'),
                      value: 'allow_selected',
                    },
                    {
                      label: $t('permissions.deny_all'),
                      value: 'deny_all',
                    },
                    {
                      label: $t('permissions.deny_selected'),
                      value: 'deny_selected',
                    }
                  ]"
                  class="team-permissions__radio-group-wrapper"
                  group-class-name="team-permissions__radio-group"
                  button-class-name="team-permissions__radio-button"
                  @change="checkGeoPermission(pvPermissions.countries_allowed_mode)"
                >
                  <UiSelectElement
                    v-model="pvPermissions.countries_allowed_list"
                    :placeholder="$t(`permissions.add_country`)"
                    :list="countries"
                    size="big"
                    search-param="name"
                    option-value-param="code"
                    filterable
                    multiple
                    collapse-tag-tooltip
                    :max-collapse-tags="1"
                    :error="errors.countries_allowed_list"
                    :disabled="pvPermissions.countries_allowed_mode === 'allow_all' || pvPermissions.countries_allowed_mode === 'deny_all'"
                  />
                </UiRadioGroup>
              </div>
            </div>
          </div>
        </div>
      </ElCollapseItem>
    </ElCollapse>
  </div>
</template>

<script>
import { h, resolveComponent } from 'vue';
import { mapGetters } from 'vuex';
import { dependsOnConfig, requiresForConfig, resetFieldsConfig } from '@/configs/permissions';
import { applyPermissionsSnapshot, getPermissionsObject, getPermissionsSnapshot, sortPermissionsSnapshot } from '@/helpers/permissions';
import PermissionTree from '@/components/PermissionTree.vue';
import PermissionTreeCommon from '@/components/PermissionTreeCommon.vue';
import errorHandleMixin from '@/views/mixins/error-hadle';
import Vnodes from '@/components/VNodes.vue';

export default {
  name: 'Permissions',
  components: {
    PermissionTree,
    PermissionTreeCommon,
    Vnodes,
  },
  mixins: [
    errorHandleMixin,
  ],
  props: {
    teamUsers: {
      type: Array,
      default() {
        return [];
      },
    },
    permissions: {
      type: Object,
      default() {
        return {
          affiliates_types_edit: [],
          affiliates_types_view: [],
          players_available_property_groups: [],
          media_buying_reports_affiliates_types_view: [],
          reports_affiliates_types: [],
          media_buying_payments_affiliates_types_view: [],
          media_buying_payments_affiliates_types_review: [],
          media_buying_posts_affiliates_types_view: [],
          media_buying_posts_affiliates_types_review: [],
          media_buying_posts_statuses_visible: [],
          reports_view_affiliates_visibility_teammates_id: [],
          offers_link_to_catalog_categories_allowed_mode: 'allow_all',
          offers_link_to_catalog_categories_allowed_list: [],
        };
      },
    },
    team: {
      type: Object,
      default() {
        return {};
      },
    },

    edit: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  emits: ['update:edit'],

  data() {
    return {
      isLoading: false,
      isCategoriesLoading: false,
      activeColor: 'var(--text-primary)',
      inactiveColor: 'var(--text-negative)',
      pvPermissions: {},
      users: null,
      currencyOptions: [],
      dataCategories: {},
      errors: {},
      isEdited: true,
      permissionSnapshots: {},
      activePermissions: ['reports'],
      crmWeight: {
        all: 3,
        teammates: 2,
        own: 1,
        deny: 0,
      },
      crmAllowOptions: {
        all: ['all', 'teammates', 'own', 'deny'],
        teammates: ['teammates', 'own', 'deny'],
        own: ['own', 'deny'],
        deny: ['deny'],
      },
    };
  },

  computed: {
    ...mapGetters({
      countries: 'misc/countries',
    }),

    activeTeamId: {
      get() {
        return this.$route.params.id ? this.$route.params.id : '';
      },
    },

    statusList() {
      return [
        {
          label: this.$t('permissions.on_review'),
          value: 'on_review',
        },
        {
          label: this.$t('permissions.approved'),
          value: 'approved',
        },
        {
          label: this.$t('permissions.for_rework'),
          value: 'for_rework',
        },
        {
          label: this.$t('permissions.declined'),
          value: 'declined',
        },
      ];
    },

    partnersTypeList() {
      return [
        {
          label: this.$t('permissions.independent'),
          value: 'independent',
        },
        {
          label: this.$t('permissions.other_teams_affiliates'),
          value: 'other_teams_affiliates',
        },
        {
          label: this.$t('permissions.own_affiliates'),
          value: 'own_affiliates',
        },
      ];
    },

    crmRadioList() {
      return [
        {
          label: this.$t('permissions.all'),
          value: 'all',
        },
        {
          label: this.$t('permissions.own'),
          value: 'own',
        },
        {
          label: this.$t('permissions.teammates'),
          value: 'teammates',
        },
        {
          label: this.$t('permissions.deny'),
          value: 'deny',
        },
      ];
    },
  },

  watch: {
    permissions: {
      handler(value) {
        this.getUsers();
        this.getCurrencies();
        this.pvPermissions = this.$_.cloneDeep(value);
      },
      immediate: true,
    },

    pvPermissions: {
      handler(value) {
        this.isEdited = this.$_.isEqual(this.permissions, value);
        this.$emit('update:edit', this.isEdited);
      },
      deep: true,
    },

    'pvPermissions.crm_segments_view': {
      handler() {
        this.checkWeight('crm_segments_view', 'crm_segments_edit');
      },
      deep: true,
    },
    'pvPermissions.crm_segments_edit': {
      handler() {
        this.checkWeight('crm_segments_edit', 'crm_segments_review');
      },
      deep: true,
    },
    'pvPermissions.crm_activities_view': {
      handler() {
        this.checkWeight('crm_activities_view', 'crm_activities_edit');
        this.checkWeight('crm_activities_view', 'crm_activities_run');
        this.checkWeight('crm_activities_view', 'crm_activities_review');
      },
      deep: true,
    },
  },

  created() {
    this.$eventBus.$on('save-changes', this.postTeamPermissions);
    this.$eventBus.$on('cancel-changes', this.cancelEdit);
  },

  mounted() {
    this.getCategories();
  },

  beforeUnmount() {
    this.$eventBus.$off('save-changes', this.postTeamPermissions);
    this.$eventBus.$off('cancel-changes', this.cancelEdit);
  },

  methods: {
    getUsers() {
      this.isLoading = true;
      this.errors = {};
      const _query = {
        team_id: this.activeTeamId,
      };
      this.$api.getAdmins(_query).then((response) => {
        this.users = response.data.payload;
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data?.errors) || {};
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getCurrencies() {
      this.$api.getMiscCustomerCurrencies().then((res) => {
        this.currencyOptions = res.data.payload;
      });
    },
    checkWeight(currentOption, childOption) {
      const currentOptionVal = this.pvPermissions[currentOption];
      const childOptionVal = this.pvPermissions[childOption];
      if (childOptionVal && (this.crmWeight[childOptionVal] > this.crmWeight[currentOptionVal])) {
        this.pvPermissions[childOption] = this.pvPermissions[currentOption];
      }
    },
    isDisabledOption(property, option) {
      const value = this.pvPermissions?.[property];
      return value ? !this.crmAllowOptions[value].includes(option) : true;
    },

    async postTeamPermissions() {
      this.errors = {};
      await this.$api.postTeamPermissions(this.activeTeamId, this.pvPermissions).then((response) => {
        this.$eventBus.$emit('update-permissions', response.data.payload);
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data?.errors) || {};
        });
    },

    checkGeoPermission(permission) {
      this.errors = {};
      if (permission === 'allow_all' || permission === 'deny_all') {
        this.pvPermissions.countries_allowed_list = [];
      }
    },

    onOffersCatalogModeChange(val) {
      if (val === 'allow_all') {
        this.pvPermissions.offers_link_to_catalog_categories_allowed_list = [];
      }
    },

    onOffersCatalogIdsChange(val) {
      if (this.pvPermissions.offers_link_to_catalog_categories_allowed_mode === 'allow_all' && val && val.length > 0) {
        this.pvPermissions.offers_link_to_catalog_categories_allowed_mode = 'allow_selected';
      }
    },

    getCategories() {
      this.isCategoriesLoading = true;
      this.$api.getAffiliateOffersCatalogCategories().then((res) => {
        // this.dataCategories = res.data.payload.reduce((acc, item) => {
        //   acc[item.id] = item.name;
        //   return acc;
        // }, {});
        this.dataCategories = res.data.payload;
      }).finally(() => {
        this.isCategoriesLoading = false;
      });
    },

    cancelEdit() {
      this.errors = {};
      this.pvPermissions = this.$_.cloneDeep(this.permissions);
    },

    permissionIsDeny(permission) {
      return this.pvPermissions[permission] === 'deny';
    },

    restoreClearedCheckboxFields(snapshot) {
      if (!snapshot) return;
      Object.entries(snapshot).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length && !this.pvPermissions[key]?.length) {
          this.pvPermissions[key] = [...value];
        }
      });
    },

    updatePermissions(currentPermission) {
      const currentPermissionsSettings = requiresForConfig[currentPermission];
      if (currentPermissionsSettings !== undefined && this.permissionIsDeny(currentPermission)) {
        // Get current state of permissions for switch off and save
        const permissionShapshot = getPermissionsSnapshot(this.pvPermissions, currentPermissionsSettings);
        this.permissionSnapshots = { ...this.permissionSnapshots, [currentPermission]: permissionShapshot };

        Object.assign(this.pvPermissions, getPermissionsObject(currentPermissionsSettings));

        const resetFields = resetFieldsConfig[currentPermission];
        if (resetFields) {
          Object.entries(resetFields).forEach(([key, value]) => {
            this.pvPermissions[key] = value;
          });
        }
      } else {
        // Return saved permissions state
        const permissionShapshot = sortPermissionsSnapshot(
          this.permissionSnapshots[currentPermission],
          this.pvPermissions,
        );
        applyPermissionsSnapshot(this.pvPermissions, permissionShapshot);

        if (currentPermissionsSettings) {
          const defaults = getPermissionsObject(currentPermissionsSettings);
          currentPermissionsSettings.forEach((key) => {
            if (this.pvPermissions[key] === undefined) {
              this.pvPermissions[key] = defaults[key] !== undefined ? defaults[key] : [];
            }
          });
        }

        if (currentPermission === 'offers_edit') {
          this.pvPermissions.offers_link_to_catalog_categories_allowed_list = [];
          this.pvPermissions.offers_link_to_catalog_categories_allowed_mode = 'allow_all';
        }
      }
    },

    getPermissionDepends(currentPermission) {
      return dependsOnConfig[currentPermission] ? dependsOnConfig[currentPermission] : [];
    },

    permissionIsDisabled(currentPermission) {
      const dependsOn = this.getPermissionDepends(currentPermission);

      return dependsOn.some((dependency) => this.pvPermissions[dependency] === 'deny');
    },

    renderPermissionSwitchControl(permissionName) {
      const uiSwitch = h(
        resolveComponent('ui-switch'),
        {
          class: 't:px-8',
          disabled: this.permissionIsDisabled(permissionName),
          activeValue: 'allow',
          inactiveValue: 'deny',
          modelValue: this.pvPermissions[permissionName],
          onChange: (value) => {
            const settings = requiresForConfig[permissionName];
            const checkboxBackup = value === 'allow' && settings
              ? getPermissionsSnapshot(this.pvPermissions, settings)
              : null;

            this.pvPermissions[permissionName] = value;
            this.updatePermissions(permissionName);

            if (checkboxBackup) {
              this.$nextTick(() => this.restoreClearedCheckboxFields(checkboxBackup));
            }
          },
        });

      const depends = this.getPermissionDepends(permissionName)
        .map(
          (dependency) => h(
            'li',
            {
              class: {
                'dependency-item': true,
                selected: this.pvPermissions[dependency] === 'allow',
              },
            },
            this.$t(`permissions.list.${dependency}`),
          ),
        );

      const dependsOnText = h(
        'h3',
        { class: 'depends-on-header' },
        this.$t('permissions.depends'),
      );

      const contentSlot = h(
        'div',
        {},
        [dependsOnText, depends],
      );

      const elTooltip = h(
        resolveComponent('el-tooltip'),
        {
          placement: 'right',
        },
        {
          content: () => contentSlot,
          default: () => uiSwitch,
        },
      );

      const switchWrapper = h(
        'div',
        { class: 'values' },
        depends.length
          ? [elTooltip]
          : [uiSwitch],
        );

      const label = h(
        'span',
        { class: 'label' },
        this.$t(`permissions.list.${permissionName}`),
      );

      return h(
        'div',
        { class: 'field' },
        [label, switchWrapper],
      );
    },
  },
};
</script>

<style lang="scss">
.depends-on-header {
  margin-bottom: 5px;
}

.dependency-item {
  &.selected {
    text-decoration: line-through;
  }
}
</style>
